import React, { useEffect, useRef } from 'react';
import './PrivacyModal.css';

function PrivacyModal({ onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="legal-backdrop" onClick={onClose} role="presentation">
      <div
        className="legal-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="legal-header">
          <h2 className="legal-title" id="privacy-title">Política de Privacidade</h2>
          <button
            ref={closeRef}
            className="legal-close"
            onClick={onClose}
            aria-label="Fechar política de privacidade"
          >
            ✕
          </button>
        </div>

        <div className="legal-body">
          <p className="legal-updated">Última atualização: abril de 2025</p>

          <h3>1. Quem somos</h3>
          <p>
            O <strong>Painel Saneamento Vivo</strong> é uma plataforma de visualização geoespacial de
            dados de saneamento básico. O controlador dos dados pessoais é a organização responsável
            pela operação desta plataforma. Para questões relacionadas à privacidade, entre em contato
            pelo e-mail: <a href="mailto:admin@saneamentovivo.com.br">admin@saneamentovivo.com.br</a>.
          </p>

          <h3>2. Dados pessoais coletados</h3>
          <p>Coletamos e processamos os seguintes dados pessoais dos usuários cadastrados:</p>
          <ul>
            <li><strong>Nome completo</strong> — identificação do usuário na plataforma</li>
            <li><strong>Endereço de e-mail</strong> — login e comunicações do sistema</li>
            <li><strong>Organização/empresa</strong> — contexto de uso da plataforma</li>
            <li><strong>Senha</strong> — armazenada exclusivamente em formato cifrado (bcrypt); não temos acesso à senha original</li>
            <li><strong>Logs de acesso</strong> — endereço IP e user-agent registrados automaticamente pelo servidor web (nginx) para fins de segurança</li>
          </ul>

          <h3>3. Finalidade do tratamento</h3>
          <p>Os dados são utilizados exclusivamente para:</p>
          <ul>
            <li>Autenticação e controle de acesso à plataforma</li>
            <li>Comunicações relacionadas ao sistema (aprovação de conta, redefinição de senha)</li>
            <li>Segurança e auditoria de acessos</li>
          </ul>
          <p>Não utilizamos os dados para fins publicitários, não os vendemos nem os compartilhamos com terceiros para fins comerciais.</p>

          <h3>4. Base legal</h3>
          <p>
            O tratamento dos dados pessoais é realizado com fundamento no <strong>art. 7º, II da LGPD</strong>
            (cumprimento de obrigação legal) e <strong>art. 7º, IX</strong> (legítimo interesse do controlador),
            para operação segura da plataforma de informação pública sobre saneamento.
          </p>

          <h3>5. Retenção dos dados</h3>
          <p>
            Os dados pessoais são mantidos enquanto a conta estiver ativa. Após solicitação de exclusão,
            os dados são removidos ou anonimizados em até <strong>30 dias</strong>, exceto quando a
            retenção for exigida por obrigação legal.
          </p>

          <h3>6. Seus direitos como titular</h3>
          <p>Nos termos do <strong>art. 18 da LGPD</strong>, você tem direito a:</p>
          <ul>
            <li><strong>Acesso</strong> — solicitar confirmação e cópia dos seus dados</li>
            <li><strong>Correção</strong> — corrigir dados incompletos ou desatualizados</li>
            <li><strong>Eliminação</strong> — solicitar a exclusão dos dados desnecessários</li>
            <li><strong>Portabilidade</strong> — receber seus dados em formato estruturado (JSON/CSV)</li>
            <li><strong>Revogação do consentimento</strong> — quando aplicável</li>
            <li><strong>Informação</strong> — ser informado sobre compartilhamentos realizados</li>
          </ul>
          <p>
            Para exercer seus direitos, envie um e-mail para{' '}
            <a href="mailto:admin@saneamentovivo.com.br">admin@saneamentovivo.com.br</a>.
            Responderemos em até <strong>15 dias corridos</strong>.
          </p>

          <h3>7. Segurança</h3>
          <p>Adotamos as seguintes medidas técnicas de proteção:</p>
          <ul>
            <li>Transmissão de dados via <strong>HTTPS/TLS</strong></li>
            <li>Senhas cifradas com <strong>bcrypt</strong></li>
            <li>Autenticação por <strong>tokens JWT</strong> com expiração definida</li>
            <li>Controle de acesso por perfil (moderador, gestor, prestadora, sociedade)</li>
          </ul>

          <h3>8. Cookies e armazenamento local</h3>
          <p>
            Esta plataforma utiliza <strong>armazenamento local (localStorage)</strong> do navegador
            exclusivamente para manter a sessão autenticada e preferências de acessibilidade
            (contraste, tamanho de fonte). Não utilizamos cookies de rastreamento ou publicidade.
          </p>

          <h3>9. Contato — Encarregado de Dados</h3>
          <p>
            Para questões relacionadas a esta Política de Privacidade ou ao tratamento de dados pessoais:
          </p>
          <p>
            <strong>E-mail:</strong>{' '}
            <a href="mailto:admin@saneamentovivo.com.br">admin@saneamentovivo.com.br</a>
          </p>
        </div>

        <div className="legal-footer">
          <button className="legal-btn-close" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyModal;
